module.exports = __webpack_public_path__ + "img/Maradona-3.08379b55.webp";